import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';

class Mitra extends Component {
  render() {
    return (
      <>
        <div className="content bottom-10 top-30">
          <h5 className="float-left font-600">Mitra Perusahaan</h5>
          <div className="clear"></div>
        </div>
        <OwlCarousel
          items={2}
          loop={true} // Loop aktif
          autoplay={true} // Mengaktifkan autoplay
          autoplayTimeout={2000} // Interval antar slide (2 detik)
          autoplaySpeed={2000} // Kecepatan transisi antar slide
          autoplayHoverPause={false} // Tidak berhenti saat hover
          dots={false}
          stagePadding={30}
          lazyLoad={true}
          margin={10}
          smartSpeed={2000} // Kecepatan transisi (ms)
          slideTransition="ease-in-out" // Transisi yang halus
        >
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img style={{ marginTop: '25px' }} src="/ywci/mitra/1.jpg" alt="Mitra 1" />
          </div>
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img style={{ marginTop: '25px' }} src="/ywci/mitra/2.jpg" alt="Mitra 2" />
          </div>
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img src="/ywci/mitra/3.jpg" alt="Mitra 3" />
          </div>
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img src="/ywci/mitra/4.jpg" alt="Mitra 4" />
          </div>
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img src="/ywci/mitra/5.jpg" alt="Mitra 5" />
          </div>
          <div
            style={{ height: '200px' }}
            className="item bg-theme round-small shadow-small center-text bottom-30"
          >
            <img src="/ywci/mitra/6.jpg" alt="Mitra 6" />
          </div>
        </OwlCarousel>
      </>
    );
  }
}

export default Mitra;
